export const checkBaseInfo = (product) => {
    if(!product.isRef && !product.referenceProductId) {
        return false;
    }
    return (
        product.nom && product.DCI && product.forme &&
        product.dosage && product.familleTherapeutique &&
        product.fabricant && product.classesPharmacologiques
    );
};
export const checkRefInfo = (product) => {
    if(!product.isRef) {
        return true;
    }
    return (
        product.proprietes && product.indications &&
        product.posologie && product.contreIndications &&
        product.effetsIndesirables && product.precautionsEmploi &&
        product.interactionsMedicamenteuses
    );
};